export default {
  address: 'Adresa',
  city: 'Mesto',
  companyAutocomplete: 'Zadajte adresu',
  country: 'Krajina',
  fillManually: 'Vyplniť manuálne',
  search: 'Vyhľadať adresu',
  streetAndNumber: 'Ulica a číslo domu',
  zip: 'PSČ'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/address.js